export default __webpack_public_path__ + "static/media/Asset 4_11zon.9c164e1d.webp";